import { Turbo } from "@hotwired/turbo-rails"
import { startKeyboardOffset } from "./utils/keyboard_offset"

function showConfirmDialog({ title, message, buttonText, inputMatch, danger }) {
  return new Promise((resolve) => {
    const dialog = document.createElement("dialog")
    dialog.className = "confirm-dialog"

    const hasInput = !!inputMatch

    dialog.innerHTML = `
      <div class="confirm-dialog-content">
        <h3 class="confirm-dialog-title">${escapeHtml(title)}</h3>
        <p class="confirm-dialog-message">${escapeHtml(message)}</p>
        ${hasInput ? `
          <label class="confirm-dialog-input-label">
            Type <strong>${escapeHtml(inputMatch)}</strong> to confirm
          </label>
          <input type="text" class="confirm-dialog-input input" autocomplete="off" spellcheck="false">
        ` : ""}
        <div class="confirm-dialog-actions">
          <button type="button" class="btn btn-sm confirm-dialog-cancel">Cancel</button>
          <button type="button" class="btn btn-sm ${danger ? "confirm-dialog-btn-danger" : "btn-primary"}"
                  data-confirm-btn ${hasInput ? "disabled" : ""}>
            ${escapeHtml(buttonText)}
          </button>
        </div>
      </div>
    `

    document.body.appendChild(dialog)

    const confirmBtn = dialog.querySelector("[data-confirm-btn]")
    const cancelBtn = dialog.querySelector(".confirm-dialog-cancel")
    const input = dialog.querySelector(".confirm-dialog-input")

    let stopKeyboardOffset = null

    const cleanup = (result) => {
      if (stopKeyboardOffset) {
        stopKeyboardOffset()
        stopKeyboardOffset = null
      }
      dialog.addEventListener("transitionend", () => dialog.remove(), { once: true })
      dialog.close()
      // Fallback removal if no transition fires
      setTimeout(() => { if (dialog.parentNode) dialog.remove() }, 200)
      resolve(result)
    }

    cancelBtn.addEventListener("click", () => cleanup(false))
    confirmBtn.addEventListener("click", () => cleanup(true))

    dialog.addEventListener("close", () => {
      // Escape key closes dialog natively
      if (dialog.parentNode) cleanup(false)
    })

    if (input) {
      input.addEventListener("input", () => {
        confirmBtn.disabled = input.value !== inputMatch
      })
      input.addEventListener("keydown", (e) => {
        if (e.key === "Enter" && input.value === inputMatch) cleanup(true)
      })
    }

    dialog.showModal()

    if (hasInput) {
      stopKeyboardOffset = startKeyboardOffset(dialog)
    }

    // Focus input or confirm button
    if (input) {
      input.focus()
    } else {
      cancelBtn.focus()
    }
  })
}

function escapeHtml(str) {
  const div = document.createElement("div")
  div.textContent = str
  return div.innerHTML
}

Turbo.config.forms.confirm = (message, element, submitter) => {
  const source = submitter || element
  return showConfirmDialog({
    title: source.dataset.turboConfirmTitle || "Are you sure?",
    message,
    buttonText: source.dataset.turboConfirmButton || "Confirm",
    inputMatch: source.dataset.turboConfirmInput,
    danger: !!source.dataset.turboConfirmButton
  })
}
